import type { WorkshopNavItem } from './workshopNavTypes';

export const WORKSHOP_SERVICES_NAV: WorkshopNavItem[] = [
    { resource: 'jobEstimate', label: 'Job Estimate' },
    { resource: 'estimateApproval', label: 'Estimate Approval' },
    { resource: 'jobCard', label: 'Job Card' },
    { resource: 'workshopFloor', label: 'Workshop Floor' },
];
